import React, { useState, useEffect } from "react";
import sortBy from "lodash/sortBy";
import { paragraphType } from "./misc/custom-prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import * as Styled from "./misc/styled";
import { QAList } from "./components";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgb(0, 0, 0, 0.25);
`;

const Topic = ({ title, header, paragraphs, btnText, qas }) => {
  const [visible, toggleVisibility] = useState(false);
  const handleOnClick = (e) => {
    e.preventDefault();
    toggleVisibility(!visible);
  };

  useEffect(() => {
    document.querySelector("body").style.overflow = visible
      ? "hidden"
      : "visible";
  }, [visible]);

  return (
    <Styled.TopicContainer>
      <h4 className="topic__title">{title}</h4>
      <p className="topic__header">{header}</p>
      <div className="topic__topic-list">
        {sortBy(paragraphs, ["order", "value"]).map((o) => (
          <div key={o.id}>
            <FontAwesomeIcon icon={faCheck} />
            <span>{o.value}</span>
          </div>
        ))}
      </div>
      <div className="topic__btn">
        <button onClick={handleOnClick}>{btnText}</button>
      </div>
      {visible && (
        <ModalOverlay>
          <QAList data={qas} toggle={handleOnClick} />
        </ModalOverlay>
      )}
    </Styled.TopicContainer>
  );
};

Topic.propTypes = {
  ...paragraphType,
};

export default Topic;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/QA.js